/**
 * Removes the following special characters from the input string:
 * & / \ # , + ( ) $ ~ % . ' " : * ? < > { }
 *
 * @param {string} string - The input string to sanitize.
 * @returns {string} - The string with special characters removed.
 */
export const removeSpecialCharacters = (string) => {
  return string.replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '');
};

/**
 * Adds a space in place of any `<br>` or `<br/>` HTML tags found in the input string.
 *
 * @param {string} [string=''] - The input string to process. Defaults to an empty string if not provided.
 * @returns {string} - The processed string with `<br>` tags replaced by a space.
 *
 */
export const addSpaceForBreakTag = (string = '') => {
  return string?.replace(/<\s?br\s?\/?>/g, ' ');
};

/**
 * Removes all HTML tags from the input string.
 *
 * @param {string} [string=''] - The input string to process. Defaults to an empty string if not provided.
 * @returns {string} - The processed string with all HTML tags removed.
 *
 */
export const stripHtml = (string = '') => {
  return string?.replace(/<[^>]*?>/g, '');
};

/**
 * Removes trailing newline characters from a string.
 *
 * @param {string|any} value - The value to process.
 * @returns {string|any} The string without trailing newlines, or the original value if not a string.
 */
export const removeTrailingNewline = (value) => {
  if (typeof value === 'string' && value.endsWith('\n')) {
    return value.replace(/\n+$/, '');
  }
  return value;
};
